"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productInfoNameClassName = exports.PRODUCT_INFO = void 0;
const PRODUCT_INFO = exports.PRODUCT_INFO = 'product-info';
const productInfoNameClassName = exports.productInfoNameClassName = 'product-info-name';
//# sourceMappingURL=constants.js.map